import React, { useEffect, useRef } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import allreportsdata from "../../../json-data/allreports.json";
import allReportsHindidata from "../../../json-data/allReportsHindi.json";
import { fetchArchiveServicesCWSNEnrolmentData } from "../../../redux/thunks/archiveServicesThunk";
import { useExportToExcel } from "../../../pdfAndExcellUtils/pdfAndExcellUtils";

import {
  initialFilterEnrolmentData,
  state_gov_mgt_code,
  gov_aided_mgt_code,
  pvt_uaided_mgt_code,
  ctrl_gov_mgt_code,
  other_mgt_code,
  pr_sch_code,
  upr_pr_code,
  hr_sec_code,
  sec_sch_code,
  pre_pr_sch_code,
  selectedDYear,
  nationalWiseName,
  stateWiseName,
  district,
  districtWiseName,
  blockWiseName,
  block,
  generateTextContent,
  foundational_preparatory,
  middle,
  secondary,
  excelStyles
} from "../../../constants/constants";

import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { columnsConfigFor4007 } from "../../../constants/constants";

import "../infra.css";
import "../report.scss";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { useLocation } from "react-router-dom";
import { GlobalLoading } from "../../GlobalLoading/GlobalLoading";
import { useTranslation } from "react-i18next";
import FilterDropdownCommom358 from "../../Home/filter/FilterDropdownCommon358";
import { removeAllDistrict } from "../../../redux/thunks/districtThunk";
import { removeAllBlock } from "../../../redux/thunks/blockThunk";
import { handleActiveTabs } from "../../../redux/slice/headerSlice";
import { handleMissingData } from "../../../utils/handleMissingData";
import satyamevaimg from "../../../assets/images/satyameva-jayate-img.png";
import udise from "../../../assets/images/udiseplu.jpg";
import nic from "../../../assets/images/nic-sm-logo.png";
import {
  TeacherGraph2008,
  TeacherGraph2009,
  TeacherGraph2010,
} from "../TeacherGraph2008";
import { ScrollToTopOnMount } from "../../Scroll/ScrollToTopOnMount";
import { Result } from "antd";

import useReportOverallRegionSum from "../../../CustomHook/useReportOverallRegionSum";
import Footer from "../../Header/Footer";
import HighchartsReact from "highcharts-react-official";
import { Graph4007, TeacherGraph2005 } from "../TeacherReport/TeacherGraph2005";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);
const isMobile = window.matchMedia("(max-width: 767px)").matches;

export default function EnrolmentReport4007() {
  const dispatch = useDispatch();
  const location = useLocation();
  const schData = useSelector((state) => state?.cwsnEnrolment);
  const school_datas = useSelector((state) => state?.cwsnEnrolment?.data?.data);
  const [local_state, setLocalStateName] = useState("All India/National");
  const [local_district, setLocalDistrictName] = useState("District");
  const [local_block, setLocalBlockName] = useState("Block");
  const [isScrollComplete, setIsScrollComplete] = useState(false);
  const schoolFilter = useSelector((state) => state.schoolFilter);
  const filterObj = structuredClone(schoolFilter);
  const headerData = useSelector((state) => state.header);
  const local_year = window.localStorage.getItem("year");
   const [customChange, setCustomChange] = useState([]);
  const stateName = localStorage.getItem("state");
  const [groupKeys, setGroupKeys] = useState({
    schManagementBroad: false,
    schMgmtCenterDesc: false,
    schCategoryBroad: false,
    schCategoryIdDesc: false,
    schLocURDesc: false,
    category: true
  });

     const [graphDataForManagementBroad, setGraphDataForManagementBroad] =
        useState({
          categories: [],
          series: [],
        });

  useEffect(() => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
  }, []);
  useEffect(() => {
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("block", "Block");
  }, []);

  useEffect(() => {
    setLocalStateName(localStorage.getItem("state"));
    setLocalStateName(localStorage.getItem("map_state_name"));
    setLocalDistrictName(localStorage.getItem("map_district_name"));
    setLocalBlockName(localStorage.getItem("block"));
  }, [filterObj, headerData.activeTab]);

  const [mgt, setMgt] = useState("");
  const [mgt_Details, setMgtDetail] = useState("");
  const [cat, setCat] = useState("");
  const [cat_Details, setCatDetail] = useState("");
  const [ur, setUR] = useState("");
  const [multiMgt, setMultiMgts] = useState("");
  const [multiCat, setMultiCats] = useState("");
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");
  const [isCheckFilter, setIsCheckFilter] = useState(false);
  const [intialStudentData, setIntialStudentData] = useState(school_datas);
  const gridApiRef = useRef(null);
  const [activeTab, setActiveTab] = useState(type);
  const { t, i18n } = useTranslation();

  const updatedGraph = {
    blindness: 0,
    low_vision: 0,
    hearing_impairment: 0,
    speech_and_language: 0,
    locomotor_disability: 0,
    mental_illness: 0,
    specific_learning_disabilities: 0,
    cerebral_palsy: 0,
    autism_spectrum_disorder: 0,
    multiple_disability: 0,
    leprosy_cured: 0,
    dwarfism: 0,
    intellectual_disability: 0,
    muscular_dystrophy: 0,
    chronic_neurological_conditions: 0,
    multiple_sclerosis: 0,
    thalassemia: 0,
    haemophilia: 0,
    sickle_cell_disease: 0,
    acid_attack_victim: 0,
    parkinsons_disease: 0,
  };

  const [socialCategoryPieDataGraph, setSocialCategoryPieDataGraph] = useState(updatedGraph);
      
  dispatch(handleActiveTabs(activeTab));
  useEffect(() => {
    setIntialStudentData(school_datas);
  }, [school_datas]);

  // Taking the both reports data condition wise for language change
  useEffect(() => {
    const reportsData =
      i18n.language === "hi" ? allReportsHindidata : allreportsdata;

    for (const category in reportsData) {
      const foundReport = reportsData[category].find(
        (report) => report.id === parseInt(id)
      );
      if (foundReport) {
        setReport(foundReport);
        break;
      }
    }
  }, [id, i18n.language]);

  useEffect(() => {
    dispatch(allFilter(initialFilterEnrolmentData));
    dispatch(
      fetchArchiveServicesCWSNEnrolmentData(initialFilterEnrolmentData)
    );
  }, [dispatch]);
  const [report, setReport] = useState(null);
  const [gridApi, setGridApi] = useState();
  const [arrGroupedData, setArrGroupedData] = useState([]);
  const [arrGroupedGraphData, setArrGroupedGraphData] = useState([]);
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const filter_query_by_location =
    // local_state === "All India/National" ||
    local_state === "State Wise" ||
    local_district === "District Wise" ||
    local_block === "Block Wise";

  const [columns, setColumn] = useState([
    {
      headerName: "Serial Number",
      field: "Serial Number",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },

    {
      headerName: "",headerClass: "headerStyle",
      children: [
        {
          headerName: "",headerClass: "headerStyle",
          children: [
            {
              headerName: "Location",
              field: "regionName",
              hide: !filter_query_by_location,
            },
            {
              headerName: "School Management(Broad)",
              field: "schManagementBroad",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Management(Detailed)",
              field: "schMgmtCenterDesc",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Category(Broad)",
              field: "schCategoryBroad",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Category(Detailed)",
              field: "schCategoryIdDesc",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
                headerName: "Urban/Rural",
                field: "schLocURDesc",
                suppressColumnsToolPanel: true,
                hide: true,
              },
            {
                headerName: "Category",
                field: "category",
                suppressColumnsToolPanel: true,
                hide: false,
            },
           
          ],
        },
      ],
    },
    {
      headerName: "",headerClass: "headerStyle",
      children: [
      
        {
          headerName: "Balvatika-1",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "pp3G", hide: false },
            { headerName: "Boys", field: "pp3B", hide: false },
          ],
        },
        {
          headerName: "Balvatika-2",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "pp2G", hide: false },
            { headerName: "Boys", field: "pp2B", hide: false },
          ],
        },
        {
          headerName: "Balvatika-3",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "pp1G", hide: false },
            { headerName: "Boys", field: "pp1B", hide: false },
          ],
        },
        {
          headerName: "Class-1",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c1G" },
            { headerName: "Boys", field: "c1B" },
          ],
        },
        {
          headerName: "Class-2",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c2G", hide: false },
            { headerName: "Boys", field: "c2B", hide: false },
          ],
        },
        {
          headerName: "Class-3",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c3G" },
            { headerName: "Boys", field: "c3B" },
          ],
        },
        {
          headerName: "Class-4",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c4G" },
            { headerName: "Boys", field: "c4B" },
          ],
        },
        {
          headerName: "Class-5",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c5G" },
            { headerName: "Boys", field: "c5B" },
          ],
        },
        {
          headerName: "Class-6",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c6G" },
            { headerName: "Boys", field: "c6B" },
          ],
        },
        {
          headerName: "Class-7",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c7G" },
            { headerName: "Boys", field: "c7B" },
          ],
        },
        {
          headerName: "Class-8",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c8G" },
            { headerName: "Boys", field: "c8B" },
          ],
        },
        {
          headerName: "Class-9",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c9G" },
            { headerName: "Boys", field: "c9B" },
          ],
        },
        {
          headerName: "Class-10",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c10G" },
            { headerName: "Boys", field: "c10B" },
          ],
        },
        {
          headerName: "Class-11",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c11G" },
            { headerName: "Boys", field: "c11B" },
          ],
        },
        {
          headerName: "Class-12",headerClass: "headerStyle",
          hide: false,
          children: [
            { headerName: "Girls", field: "c12G" },
            { headerName: "Boys", field: "c12B" },
          ],
        },

        {
          headerName: "Overall",headerClass: "headerStyle",
          hide: false,
          children: [
            {
              headerName: "Overall",
              field: "total",
              valueGetter: (params) => (params.data ? params.data.total : null),
              aggFunc: "sum",
            },
          ],
        },
      ],
    },
  ]);

  const [defColumnDefs] = useState({
    flex: 1,
    minWidth: 150,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    // filter: true,
    autoHeaderHeight: true,
    headerClass: "headerStyle",
  });

  const countTotalPinnedWithRightVisible = (visibleArr,obj) => {
    let total = 0;
    for (const key in obj) {
     for(const key2 in visibleArr){
      if(visibleArr[key2]?.colId == key){
      const value = obj[key];
      if(key !="Serial Number" && key !="Overall" && key !="total"){
      if (Number.isInteger(value)) {
        total += value;
      }
    }
  }
    }
  }

    console.log('total', total)
    return total;
  };

  function calculateTotalOverall(data,fieldName) {
    if (!data) return 0;
    return data.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }


  function onColumnVisible(event) {
    const columnId = event?.column?.colId;
    const visible = event.visible;
     const gridApi1 = gridApiRef.current;
    
    const allData = [];

    const visibleColumns = gridApi.api.getAllDisplayedColumns();


    gridApi1.forEachNodeAfterFilter((node) => {
      if(node.data['School Management(Broad)'] !='Overall'){
    allData.push(node.data);
      }
  });

  const newArr = allData.map((item, idx) => {
    return {
      ...item,
      total: countTotalPinnedWithRightVisible(visibleColumns,item),
      "Serial Number": idx + 1,
    };
  });
  setArrGroupedData(newArr);

  const appendedObj = {};
  visibleColumns.forEach((item) => {
      appendedObj[item.colId] = calculateTotalOverall(newArr,item.colId);
  });

  appendedObj['schCategoryBroad']="";
  appendedObj['schCategoryIdDesc']="";
  appendedObj['regionName']="";
  appendedObj['schManagementBroad']="";
  appendedObj['schMgmtCenterDesc']="";
  appendedObj['schTypeDesc']="";
  appendedObj['category']="";
if(groupKeys.schManagementBroad){
  appendedObj['schManagementBroad']="Total";
}else if(groupKeys.schMgmtCenterDesc){
  appendedObj['schMgmtCenterDesc']="Total";
}else if(groupKeys.schCategoryBroad){
  appendedObj['schCategoryBroad']="Total";
}else if(groupKeys.schCategoryIdDesc){
  appendedObj['schCategoryIdDesc']="Total";
}else if(groupKeys.schTypeDesc){
  appendedObj['schTypeDesc']="Total";
}else if(groupKeys.schLocationDesc){
  appendedObj['regionName']="Total";
}else if(groupKeys.category){
  appendedObj['category']="Total";
}


    if (columnId === "schManagementBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schManagementBroad: visible,
      }));
      setMgt(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schMgmtCenterDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schMgmtCenterDesc: visible,
      }));
      setMgtDetail(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schCategoryBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryBroad: visible,
      }));
      setCat(() => (visible ? "active" : ""));

      setMultiCats(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schCategoryIdDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryIdDesc: visible,
      }));
      setCatDetail(() => (visible ? "active" : ""));

      setMultiCats(() => (visible ? "multibtn" : ""));
    }

    if (columnId === "schLocURDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schLocURDesc: visible,
      }));
      setUR(() => (visible ? "active" : ""));
    }

    if (columnId === "category") {
        setGroupKeys((prev) => ({
          ...prev,
          category: visible,
        }));
        setMgt(() => (visible ? "active" : ""));
        setMultiMgts("multibtn");
      }

      const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
      ? (  [appendedObj])
      : [];
    
      console.log('pinnedBottomRowData', pinnedBottomRowData)
      setCustomChange(pinnedBottomRowData);
  }

  const onGridReady = (params) => {
    if (!params) {
      return;
    }
    gridApiRef.current = params?.api;
    setColumnVisibility(groupKeys);
    setGridApi(params);
  };

  const setColumnVisibility = (keys) => {
    if (gridApiRef.current) {
      const gridApi = gridApiRef.current;
      Object.keys(keys)?.forEach((key) => {
        gridApi?.columnApi?.setColumnVisible(key, keys[key]);
      });
    }
  };
  const handleCustomKeyInAPIResponse = () => {
  
    const arr = [];
    school_datas?.forEach((item, idx) => {
      let appendedObj = { ...item };
      /* broad management key added*/
      if (state_gov_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "State Government";
      } else if (gov_aided_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Govt. Aided";
      } else if (pvt_uaided_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Private Unaided";
      } else if (ctrl_gov_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Central Government";
      } else if (other_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Others";
      }
      /* broad category key added*/
      if (foundational_preparatory.includes(item.schCategoryId)) {
        appendedObj.schCategoryBroad = "Foundational and Preparatory";
      } else if (middle.includes(item.schCategoryId)) {
        appendedObj.schCategoryBroad = "Middle";
      } 
      else if (secondary.includes(item.schCategoryId)) {
        appendedObj.schCategoryBroad = "Secondary";
      } 
      
      //Add disability Category
      let disabilityDesc = disabilityDsc(item);
      appendedObj.category = disabilityDesc;
    
    
      arr.push(appendedObj);
    });


    setData(arr);
    setGraphData(arr);
    setSocialCategoryPieDataGraph(updatedGraph); // Update state for pie chart
    // graphDataPrepare();
  };

  const generateKey = (item, filters) => {
    const {
      regionName,
      schManagementBroad,
      schMgmtCenterDesc,
      schCategoryBroad,
      schCategoryIdDesc,
      schLocURDesc,
      category
    } = item;
    let keyParts = [regionName];

    if (filters.schManagementBroad) keyParts.push(schManagementBroad);
    if (filters.schMgmtCenterDesc) keyParts.push(schMgmtCenterDesc);
    if (filters.schCategoryBroad) keyParts.push(schCategoryBroad);
    if (filters.schCategoryIdDesc) keyParts.push(schCategoryIdDesc);
    if (filters.schLocURDesc) keyParts.push(schLocURDesc);
    if(category != null){
         keyParts.push(category);
         return keyParts.join("-");
    }

  };

  const groupData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
      const key = generateKey(item, filters); 
      ////console.log(key,'generateKey');
      
    //   if(item.casteId==="5"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
     
    });
     console.log(groupedData,'groupedData');
     
    return Object.values(groupedData);
  };
  const handleButtonClick = (type, detailType) => {
    handleFilterClick(type, detailType);

    if (type === "School Management") {
      setMgt((prevMgt) =>
        detailType === "broad" ? (prevMgt === "active" ? "" : "active") : ""
      );
      setMgtDetail((prevMgtDetail) =>
        detailType === "desc"
          ? prevMgtDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }

    if (type === "School Category") {
      setCat((prevCat) =>
        detailType === "broad" ? (prevCat === "active" ? "" : "active") : ""
      );
      setCatDetail((prevCatDetail) =>
        detailType === "desc"
          ? prevCatDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }

    gridApiRef.current.setFilterModel(null);
    gridApiRef.current.onFilterChanged();
    
  };

  useEffect(() => {
    setColumn((prevColumns) => {
      const updatedColumns = [...prevColumns];
      const firstChild = updatedColumns[1].children[0].children;

      const updateColumnVisibility = (field, isVisible) => {
        const index = firstChild.findIndex((col) => col.field === field);
        if (index !== -1) {
          firstChild[index].hide = !isVisible;
        }
      };

      if (groupKeys.schManagementBroad !== undefined) {
        updateColumnVisibility(
          "schManagementBroad",
          groupKeys.schManagementBroad
        );
      }
      if (groupKeys.schMgmtCenterDesc !== undefined) {
        updateColumnVisibility(
          "schMgmtCenterDesc",
          groupKeys.schMgmtCenterDesc
        );
      }
      if (groupKeys.schCategoryBroad !== undefined) {
        updateColumnVisibility("schCategoryBroad", groupKeys.schCategoryBroad);
      }
      if (groupKeys.schCategoryIdDesc !== undefined) {
        updateColumnVisibility("schCategoryIdDesc", groupKeys.schCategoryIdDesc);
      }
      if (groupKeys.schLocURDesc !== undefined) {
        updateColumnVisibility("schLocURDesc", groupKeys.schLocURDesc);
      }
      if (groupKeys.category !== undefined) {
        updateColumnVisibility("category", groupKeys.category);
      }
      updateColumnVisibility("regionName", filter_query_by_location);
      const updatedDefs = updatedColumns.map((colGroup) => ({
        ...colGroup,
        children: colGroup.children?.map((col) => ({
          ...col,
          hide: firstChild.find((c) => c.field === col.field)?.hide || col.hide,
          headerClass: "headerStyle",
        })),
      }));
      const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
      const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
      ? (  pinedBottomRowDatas)
      : [];
      setTimeout(()=>{
        setCustomChange(pinnedBottomRowData);
      },10)
   
      return updatedDefs;
    });
  
    const grouped = groupData(data, groupKeys);

     const arrGroupedDataTable = handleMissingData(grouped, columns).map(
                        (item) => ({
                          ...item,
                          total:
                          item.pp1B +
                          item.pp1G +
                          item.pp2B +
                          item.pp2G +
                          item.pp3B +
                          item.pp3G +
                            item.c2G +
                            item.c3G +
                            item.c1G +
                            item.c2B +
                            item.c3B +
                            item.c1B +
                            item.c4B +
                            item.c4G +
                            item.c5B +
                            item.c5G +
                            item.c6B +
                            item.c6G +
                            item.c7B +
                            item.c7G +
                            item.c8G +
                            item.c8B +
                            item.c9G +
                            item.c9B +
                            item.c10B +
                            item.c11G +
                            item.c11B +
                            item.c12G +
                            item.c12B +
                            item.c10G,
                        })
                      );
    

    const filteredData = arrGroupedDataTable.filter(item => item.category !== null); 
    const removeSpecialSymbol = filteredData.map((item) => {
      if(item.category === '-Intellectual Disability'){
          item.category = "Intellectual Disability"
      }
      return item
    })

    setArrGroupedData(removeSpecialSymbol);
    setColumnVisibility(groupKeys);
  }, [groupKeys, data, filter_query_by_location, school_datas]);

  // using use effect to translate the data
  useEffect(() => {
    const translateColumns = (columnsArray) => {
      return columnsArray?.map((col) => {
        // Add your condition here
        if (col.headerNameKey === 'School Management(Broad)' || col.headerNameKey === 'School Management(Detailed)' || col.headerNameKey === 'School Category(Broad)'
          || col.headerNameKey === 'School Category(Detailed)' || col.headerNameKey === 'Urban/Rural' || col.headerNameKey === 'Category'
        ) {
          // For example, if the column field is 'price', apply a different translation or logic
          return {
            ...col,
            filter: true,
            headerClass: "headerStyle",
            headerName: t(col.headerNameKey),
            children: col.children ? translateColumns(col.children) : col.children,
            // Any additional modifications specific to 'price' field
            width: 150, // Example: Set width specifically for price column
          };
        }
    else{
      return {
        ...col,
        filter: false,
        headerClass: "headerStyle",
        headerName: t(col.headerNameKey),
        children: col.children ? translateColumns(col.children) : col.children,
      };
    }
        // Default behavior if the condition is not met
   
      });
    };

    const translatedColumns = translateColumns(columnsConfigFor4007);

    setColumn(translatedColumns);
  }, [t]);

  const handleFilterClick = (type, detailType) => {
    setGroupKeys((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (type === "School Management") {
        if (detailType === "broad") {
          newFilters.schManagementBroad = !prevFilters.schManagementBroad;
          newFilters.schMgmtCenterDesc = false;
        } else if (detailType === "desc") {
          newFilters.schMgmtCenterDesc = !prevFilters.schMgmtCenterDesc;
          newFilters.schManagementBroad = false;
        }
      } else if (type === "School Category") {
        if (detailType === "broad") {
          newFilters.schCategoryBroad = !prevFilters.schCategoryBroad;
          newFilters.schCategoryIdDesc = false;
        } else if (detailType === "desc") {
          // newFilters.schCategoryIdDesc = !prevFilters.schCategoryIdDesc;
          // newFilters.schCategoryBroad = false;
        }

      } 
      else if (type === "Urban/Rural") {
        newFilters.schLocURDesc = !prevFilters.schLocURDesc;
      }

      return newFilters;
    });
  };

  const getLastTrueToShowTotal = () => {
    const lastTrueKey = Object.keys(groupKeys).reduce((lastKey, key) => {
      if (groupKeys[key]) {
        return key;
      }
      return lastKey;
    }, null);
    return lastTrueKey;
  };
  function calculateTotal(fieldName) {
    if (!arrGroupedData) return 0;
    return arrGroupedData.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  function calculateTotalSum(data,fieldName) {
    if (!data) return 0;
    return data.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  const pinedBottomRowDatas = [
    {
      ...(getLastTrueToShowTotal()
        ? { [getLastTrueToShowTotal()]: "Total" }
        : { regionName: "Total" }),
        pp1B: calculateTotal("pp1B"),
        pp1G: calculateTotal("pp1G"),
        pp2B: calculateTotal("pp2B"),
        pp2G: calculateTotal("pp2G"),
        pp3B: calculateTotal("pp3B"),
        pp3G: calculateTotal("pp3G"),
      c2G: calculateTotal("c2G"),
      c2B: calculateTotal("c2B"),
      c3G: calculateTotal("c3G"),
      c3B: calculateTotal("c3B"),
      c1G: calculateTotal("c1G"),
      c1B: calculateTotal("c1B"),
      c4G: calculateTotal("c4G"),
      c4B: calculateTotal("c4B"),
      c5G: calculateTotal("c5G"),
      c5B: calculateTotal("c5B"),
      c6G: calculateTotal("c6G"),
      c6B: calculateTotal("c6B"),
      c7G: calculateTotal("c7G"),
      c7B: calculateTotal("c7B"),
      c8B: calculateTotal("c8B"),
      c8G: calculateTotal("c8G"),
      c9B: calculateTotal("c9B"),
      c9G: calculateTotal("c9G"),
      c10B: calculateTotal("c10B"),
      c10G: calculateTotal("c10G"),
      c11G: calculateTotal("c11G"),
      c11B: calculateTotal("c11B"),
      c12B: calculateTotal("c12B"),
      c12G: calculateTotal("c12G"),
      // Correct total calculation
      total:
      calculateTotal("pp1B") +
      calculateTotal("pp1G") +
      calculateTotal("pp2B") +
      calculateTotal("pp2G") +
      calculateTotal("pp3B") +
      calculateTotal("pp3G") +
        calculateTotal("c2G") +
        calculateTotal("c3G") +
        calculateTotal("c1G") +
        calculateTotal("c2B") +
        calculateTotal("c3B") +
        calculateTotal("c1B") +
        calculateTotal("c4B") +
        calculateTotal("c4G") +
        calculateTotal("c5B") +
        calculateTotal("c5G") +
        calculateTotal("c6B") +
        calculateTotal("c6G") +
        calculateTotal("c7B") +
        calculateTotal("c7G") +
        calculateTotal("c8G") +
        calculateTotal("c8B") +
        calculateTotal("c9G") +
        calculateTotal("c9B") +
        calculateTotal("c10G") +
        calculateTotal("c10B") +
        calculateTotal("c11B") +
        calculateTotal("c11G") +
        calculateTotal("c12B") +
        calculateTotal("c12G"),
    },
  ];

  /*------------Export data to Excel and PDF-------------*/
  const getHeaderToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
    const headerCellSerialNumber = {
      text: "Serial Number",
      headerName: "S.NO.",
      bold: true,
      margin: [0, 12, 0, 0],
    };
    const headerRow = columns?.map((column) => {
      const { field, headerName } = column?.getColDef();
      const sort = column?.getSort();
      const headerNameUppercase = field[0]?.toUpperCase() + field?.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
        headerName: headerName,
        bold: true,
        margin: [0, 12, 0, 0],
      };
      return headerCell;
    });
    headerRow.unshift(headerCellSerialNumber);
    return headerRow;
  };
  const getRowsToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
    const getCellToExport = (column, node) => ({
      text: gridApi.api.getValue(column, node) ?? "",
    });
    const rowsToExport = [];
    gridApi?.api?.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = [];
      rowToExport.push({ text: rowsToExport.length + 1 });
      if (!columns) {
        return;
      }
      columns?.forEach((column) => {
        rowToExport?.push(getCellToExport(column, node));
      });
      rowsToExport.push(rowToExport);
    });
    return rowsToExport;
  };
  const getDocument = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const headerRow = getHeaderToExport(gridApi);
    const rows = getRowsToExport(gridApi);
    const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
    const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
    ? (pinedBottomRowDatas)
    : [];
    const pinnedBottomRow = pinnedBottomRowData
    const date = new Date();
    const formattedDate = `${date.toLocaleDateString("en-GB", {
      weekday: "long", // Full day name (e.g., Friday)
    })}, ${date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day of the month (e.g., 13)
      month: "long", // Full month name (e.g., September)
      year: "numeric", // Full year (e.g., 2024)
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit", // Hour (e.g., 10)
      minute: "2-digit", // Minutes (e.g., 25)
      hour12: true, // 12-hour format with AM/PM
    })}`;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [12, 20],
    });
    // Function to add header
    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor("black");
      doc.setFont("Helvetica", "bold");
      // doc.text("UDISE+", 0.6, 1);

      // Add the header text
      doc.text(
        "Unified District Information System for Education",
        doc.internal.pageSize.width / 2,
        0.7,
        {
          fontStyle: "bold",

          color: "black",
          align: "center",
        }
      );
      doc.setFont("Helvetica", "normal");

      doc.setFontSize(18);

      doc.text(
        "Department of School Education & Literacy, Ministry of Education, Government of India",
        doc.internal.pageSize.width / 2,
        1.1,
        {
          // fontStyle: '',
          color: "black",
          align: "center",
        }
      );

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(`${report.report_name}`, doc.internal.pageSize.width / 2, 1.5, {
        fontSize: 12,
        fontStyle: "bold",

        color: "black",
        align: "center",
      });

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      // doc.text(`${stateName}`, doc.internal.pageSize.width / 2, 1.7, {
      //   fontSize: 12,
      //   color: "black",
      //   align: "center",
      // });

      doc.setFont("bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(
        `Academic Year : ${local_year}`,
        doc.internal.pageSize.width / 2,
        1.9,
        {
          fontSize: 12,
          color: "black",
          align: "center",
        }
      );

      const textContent = generateTextContent(
        stateName,
        nationalWiseName,
        stateWiseName,
        local_district,
        district,
        districtWiseName,
        local_block,
        block,
        blockWiseName
      );
      if (textContent) {
        doc.text(textContent, doc.internal.pageSize.width / 2, 2.3, {
          fontSize: 12,
          color: "black",
          align: "center",
        });
      }

      // Set the margin for the image from the left
      const leftMargin = 0.1; // Margin from the left (in inches)
      const topLeftX = leftMargin; // X position from the left including margin
      const topLeftY = 0; // Y position from the top (in inches)
      const imgWidth = 2; // Image width (in inches)
      const imgHeight = 2; // Image height (in inches)

      doc.setFontSize(20);
      doc.setTextColor("blue");

      // Add the satyameva image with the specified left margin
      doc.addImage(
        satyamevaimg,
        "PNG",
        topLeftX,
        topLeftY,
        imgWidth,
        imgHeight
      );

      doc.setTextColor("blue");
      doc.setFont("bold");

      // Get page dimensions
      const pageWidthE = doc.internal.pageSize.getWidth();
      const pageHeightE = doc.internal.pageSize.getHeight();

      const imgWidthE = 2.8; // Image width (in inches)
      const imgHeightE = 1.4; // Image height (in inches)
      const marginRight = 0.7; // Right margin (in inches)

      // Calculate x position for top-right corner
      const topRightX = pageWidthE - imgWidthE - marginRight;
      const topRightY = 0.3; // Y position from the top (in inches)

      // Add the education image at the top-right corner
      doc.addImage(
        udise,
        "JPG",
        topRightX, // X position for top-right
        topRightY, // Y position for top-right
        imgWidthE,
        imgHeightE
      );

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Example: Draw a rectangle around the whole page
      // doc.setLineWidth(0.02); // Thicker border for the page
      // doc.rect(0.1, 0.1, pageWidth - 0.2, pageHeight - 0.2); // x, y, width, height
    };
    // Function to add footer
    const addFooter = () => {};
    const table = [];
    table.push(headerRow.map((cell) => cell.headerName));
    rows.forEach((row) => {
      table.push(row.map((cell) => cell.text));
    });
    if (pinnedBottomRow && pinnedBottomRow.length > 0) {
      pinnedBottomRow.forEach((row) => {
        const totalRow = headerRow.map((header) => {
          let field = header.text;
          if (row.hasOwnProperty(field.charAt(0).toLowerCase() + field.slice(1))) {
            field = field.charAt(0).toLowerCase() + field.slice(1);
          } else if (row.hasOwnProperty(field.charAt(0).toUpperCase() + field.slice(1))) {
            field = field.charAt(0).toUpperCase() + field.slice(1);
          }
          return row[field] !== undefined ? row[field].toString() : "";
        });
    
        table.push(totalRow);
      });
    }
    const headers = [];
    // First row: Social Category spanning all columns
    headers.push([
      {
        content: "",
        colSpan: table[0].length,
        styles: { halign: "center" },
      },
    ]);

    // Second row: Category headers
    const secondRow = [
      { content: "", colSpan: 1, styles: { halign: "center" } },
    ];
    const visibleFields = gridApi.api.getAllDisplayedColumns().map(col => col.getColDef().field);

    // Filter only visible group headers
        const visibleGroups = columns[2].children.filter(group =>
          group.children.some(child => visibleFields.includes(child.field))
        );
    
    visibleGroups.forEach((category) => {
      secondRow.push({
        content: category.headerName,
        colSpan: category.children.length,
        styles: { halign: "center" },
      });
    });

    // const numberOfColumns = table[0].length;
    // const baseValue = 10;
    // const extraCells = numberOfColumns - baseValue;

    let extraCells = 0;
    for(let i = 0 ; i < table[0].length; i++){
      if(table[0][i] === "Location"  || table[0][i] === "School Management(Broad)"  || table[0][i] === "School Management(Detailed)" || table[0][i] === "School Category(Broad)" || table[0][i] === "School Category(Detailed)" || table[0][i] === "Urban/Rural"){
        extraCells++;
      }
    }
    
    // Add empty cells to the start of secondRow
    if (extraCells > 0) {
      for (let i = 0; i < extraCells; i++) {
        secondRow.unshift({ content: "", colSpan: 1 });
      }
    }

    const thirdRow = [{ content: "", styles: { halign: "center" } }];
    table[0].forEach((header) => {
      thirdRow.push({ content: header, styles: { halign: "center" } });
    });
    thirdRow.shift();
    headers.push(secondRow);
    headers.push(thirdRow);

    addHeader();
    doc.autoTable({
      head: headers,
      body: table.slice(1),
      theme: "grid",
      startY: 2.7,
      styles: {
        cellPadding: 0.15, // Adjust cell padding if needed
        lineColor: [0, 0, 0], // Set border color (black in this case)
        lineWidth: 0.001, // Set border width
        fillColor: [255, 255, 255], // Default background color (white)
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 14, // Set the font size for the header row
        fontStyle: "bold", // Make the header text bold (optional)
        textColor: [0, 0, 0],
        cellPadding: 0.2, // Set text color for the header row
        halign: "center",
      },

      didParseCell: function (data) {
        const headerRow = getHeaderToExport(gridApi); // Get the header row

        // Get the header text for this column
        const columnHeaderText = headerRow[data.column.index]?.text;
        const columnHeaderHeaderName = headerRow[data.column.index]?.headerName;
        // Check if the current column header is "Serial Number"
        if (columnHeaderText === "Serial Number") {
          data.cell.styles.halign = "center";
        } else if (
          columnHeaderText === "RegionName" ||
          columnHeaderText === "Location"
        ) {
          data.cell.styles.halign = "left";
        } else if (
          columnHeaderText === "SchManagementBroad" ||
          columnHeaderText === "SchCategoryBroad" ||
          columnHeaderText === "SchTypeDesc" ||
          columnHeaderText === "schLocURDesc" ||
          columnHeaderText === "schMgmtCenterDesc" ||
          columnHeaderText === "schCategoryIdDesc"
        ) {
          data.cell.styles.halign = "left";
        } else {
          data.cell.styles.halign = "right";
        }
      },

      afterPageContent: addFooter,
    });

    const totalPages = doc.internal.getNumberOfPages();
    doc.page = 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.addImage(
        nic,
        "JPG",
        0.6, // X position for top-right
        11.5, // Y position for top-right
        1,
        0.3
      );
      doc.setTextColor("black");
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.2,
        { align: "center", color: "black" }
      );

      doc.text(
        `Report generated on : ${formattedDate}`,
        doc.internal.pageSize.width - 1,
        doc.internal.pageSize.height - 0.2,
        { fontSize: 12, align: "right", color: "black" }
      );
    }
    for (let i = 0; i < totalPages; i++) {
      doc.setPage(i + 1);
      doc.autoTable({
        startY: 3.5,
      });
    }
    return doc;
  };
  const exportToPDF = () => {
    if (!gridApi) {
      return;
    }
    const doc = getDocument(gridApi);
    doc.save(`${report.report_name}.pdf`);
  };
     const { exportToExcel } = useExportToExcel(gridApi, report, local_year, stateName, nationalWiseName, stateWiseName, local_district, district, districtWiseName, local_block, block, blockWiseName, generateTextContent);
 
  const handleExportData = (e) => {
    const { value } = e.target;
    if (value === "export_pdf") {
      if (!gridApi) {
        return;
      }
      exportToPDF();
    }
    if (value === "export_excel") {
      exportToExcel();
    }
    document.getElementById("export_data").selectedIndex = 0;
  };
  useEffect(() => {
    if (intialStudentData && intialStudentData.length > 0) {
      handleCustomKeyInAPIResponse();
    }
  }, [intialStudentData, school_datas, location.pathname]);
  //  ........................Graph code statr here.....................
  // ...Start Total No. of Teacher by School Management & School Category.....
  const generateKeyGraph = (item, filters) => {
    const { schManagementBroad, schCategoryBroad } = item;
    let keyParts = [schManagementBroad, schCategoryBroad];
    return keyParts.join("-");
  };

  const groupGraphData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
      const key = generateKeyGraph(item, filters);
      
      if(item.casteId==="5"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }

      if(item.casteId==="6"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }

      if(item.casteId==="7"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }

      if(item.casteId==="8"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }
      if(item.casteId==="9"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }
      if(item.casteId==="10"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }
     
    });

    console.log('groupedData', groupedData)
    return Object.values(groupedData);
  };

  useEffect(() => {
    const grouped = groupGraphData(data, groupKeys);
    setArrGroupedGraphData(grouped);
  }, [groupKeys, graphData, filter_query_by_location, school_datas]);

  //Code For Graph 1

  // Taking Objects for category and management
  const categoryTranslations = {
    "Primary (PRY)": t("categories_school.Primary (PRY)"),
    "Upper Primary (UPR)": t("categories_school.Upper Primary (UPR)"),
    "Higher Secondary (HSEC)": t("categories_school.Higher Secondary (HSEC)"),
    "Secondary (SEC)": t("categories_school.Secondary (SEC)"),
  };

  const managementTranslations = {
    "State Government": t("managements.State Government"),
    "Govt. Aided": t("managements.Govt. Aided"),
    "Private Unaided": t("managements.Private Unaided"),
    "Central Government": t("managements.Central Government"),
    Others: t("managements.Others"),
  };

  // function to translate the data dynamically
  const translateDataKeys = (
    data,
    categoryTranslations,
    managementTranslations
  ) => {
    return data.map((item) => ({
      ...item,
      schCategoryBroad:
        categoryTranslations[item.schCategoryBroad] || item.schCategoryBroad,
      schManagementBroad:
        managementTranslations[item.schManagementBroad] ||
        item.schManagementBroad,
    }));
  };

  const processGraphData = (data) => {
    const translatedData = translateDataKeys(
      data,
      categoryTranslations,
      managementTranslations
    );

    // Define categories and managements in Hindi
    const categories = Object.values(categoryTranslations);
    const managements = [
      { name: managementTranslations["State Government"], color: "#751539" },
      { name: managementTranslations["Govt. Aided"], color: "#E6694A" },
      { name: managementTranslations["Private Unaided"], color: "#F5BF55" },
      { name: managementTranslations["Central Government"], color: "#BCE263" },
      { name: managementTranslations["Others"], color: "#57C1BB" },
    ];
    const abbreviateCategory = (category) => {
      return category.replace(/\s*\([^)]*\)/, "");
    };

    const seriesData = managements.map((management) => ({
      name: management.name,
      data: categories.map((category) => {
        const total = translatedData
          .filter(
            (item) =>
              item.schCategoryBroad === category &&
              item.schManagementBroad === management.name
          )
          .reduce((acc, curr) => acc + curr.totalSchCatWise, 0);
        return total;
      }),
      color: management.color,
    }));

    const abbreviatedCategories = categories.map(abbreviateCategory);

    const abbreviatedSeriesData = seriesData.map((series) => ({
      ...series,
      name: series.name.replace("Government", "Govt."),
    }));

    return {
      categories: abbreviatedCategories,
      series: abbreviatedSeriesData,
    };
  };

  const graphScmSchData = processGraphData(arrGroupedGraphData);

  useEffect(() => {
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesCWSNEnrolmentData(initialFilterEnrolmentData)
      );
    }
    if (headerData.activeTab === "graph") {
      graphDataPrepare();
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesCWSNEnrolmentData(initialFilterEnrolmentData)
      );
    }
  }, [headerData.activeTab, dispatch]);

  const handleScrollComplete = () => {
    setIsScrollComplete(true);
  };
  // Use `arrGroupedData` as the source data and apply the `handleMissingData` function to replace null values with "0".
  // The `handleMissingData` function is used to process data and ensure missing values are replaced,
  // which is then displayed in AG Grid using the processed data.

  const arrGroupedDataTable = handleMissingData(arrGroupedData, columns).map(
    (item) => ({
      ...item,
      total:
      item.pp1B +
      item.pp1G +
      item.pp2B +
      item.pp2G +
      item.pp3B +
      item.pp3G +
        item.c2G +
        item.c3G +
        item.c1G +
        item.c2B +
        item.c3B +
        item.c1B +
        item.c4B +
        item.c4G +
        item.c5B +
        item.c5G +
        item.c6B +
        item.c6G +
        item.c7B +
        item.c7G +
        item.c8G +
        item.c8B +
        item.c9G +
        item.c9B +
        item.c10B +
        item.c11G +
        item.c11B +
        item.c12G +
        item.c12B +
        item.c10G,
    })
  );
  
     // Optimize category count calculation
     const calculateSocialCategoryPieGraph = (item) => {
      return [
            'pp1G',
            'pp2B',
            'pp2G',
            'pp3B',
            'pp3G',
            'c2G',
            'c2B',
            'c3G',
            'c3B',
            'c1G',
            'c1B',
            'c4G',
            'c4B',
            'c5G',
            'c5B',
            'c6G',
            'c6B',
            'c7G',
            'c7B',
            'c8B',
            'c8G',
            'c9B',
            'c9G',
            'c10B',
            'c10G',
            'c11G',
            'c11B',
            'c12G',
            'c12B',
      ].reduce((sum, key) => sum + (parseInt(item[key]) || 0), 0);
    };


    const disabilityDsc = (item) => {
      let desc = "";
      if (item.disablityId == "1") {
        desc = "Blindness";
        updatedGraph["blindness"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "2") {
        desc = "Low Vision";
        updatedGraph["low_vision"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "3") {
        desc = "Hearing impairment";
        updatedGraph["hearing_impairment"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "4") {
        desc = "Speech and Language";
        updatedGraph["speech_and_language"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "5") {
        desc = "Locomotor Disability";
        updatedGraph["locomotor_disability"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "6") {
        desc = "Mental illness";
        updatedGraph["mental_illness"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "7") {
        desc = "Specific Learning Disabilities";
        updatedGraph["specific_learning_disabilities"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "8") {
        desc = "Cerebral palsy";
        updatedGraph["cerebral_palsy"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "9") {
        desc = "Autism Spectrum Disorder";
        updatedGraph["autism_spectrum_disorder"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "10") {
        desc = "Multiple Disability incl. deaf, blindness";
        updatedGraph["multiple_disability"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "11") {
        desc = "Leprosy Cured students";
        updatedGraph["leprosy_cured"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "12") {
        desc = "Dwarfism";
        updatedGraph["dwarfism"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "13") {
        desc = "-Intellectual Disability";
        updatedGraph["intellectual_disability"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "14") {
        desc = "Muscular Dystrophy";
        updatedGraph["muscular_dystrophy"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "15") {
        desc = "Chronic Neurological conditions";
        updatedGraph["chronic_neurological_conditions"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "16") {
        desc = "Multiple Sclerosis";
        updatedGraph["multiple_sclerosis"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "17") {
        desc = "Thalassemia";
        updatedGraph["thalassemia"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "18") {
        desc = "Haemophilia";
        updatedGraph["haemophilia"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "19") {
        desc = "Sickle Cell disease";
        updatedGraph["sickle_cell_disease"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "20") {
        desc = "Acid Attack victim";
        updatedGraph["acid_attack_victim"] += calculateSocialCategoryPieGraph(item);
      } else if (item.disablityId == "21") {
        desc = "Parkinson’s disease";
        updatedGraph["parkinsons_disease"] += calculateSocialCategoryPieGraph(item);
      }
    
      console.log('updatedGraph', updatedGraph)
      return desc || null;
    };

  const result = useReportOverallRegionSum(arrGroupedData);
  const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
  const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
  ? (  pinedBottomRowDatas)
  : [];

  const graphObject = [
    { name: "Blindness",  data: [], },
    { name: "Low Vision", data: [] },
    { name: "Hearing impairment", data: [] },
    { name: "Speech and Language", data: [] },
    { name: "Locomotor Disability", data: [] },
    { name: "Mental illness", data: [] },
    { name: "Specific Learning Disabilities", data: [] },
    { name: "Cerebral palsy", data: [] },
    { name: "Autism Spectrum Disorder", data: [] },
    { name: "Multiple Disability incl. deaf, blindness", data: [] },
    { name: "Leprosy Cured students", data: [] },
    { name: "Dwarfism", data: [] },
    { name: "-Intellectual Disability", data: [] },
    { name: "Muscular Dystrophy", data: [] },
    { name: "Chronic Neurological conditions", data: [] },
    { name: "Multiple Sclerosis", data: [] },
    { name: "Thalassemia", data: [] },
    { name: "Haemophilia", data: [] },
    { name: "Sickle Cell disease", data: [] },
    { name: "Acid Attack victim", data: [] },
    { name: "Parkinson’s disease", data: [] },
  ];

  let graphObjectCategoryBroad = [
    { name: "Foundational and Preparatory", data: {} },
    { name: "Middle", data: {} },
    { name: "Secondary", data: {} },
  ];

      // Mock translation function
  const trans = (key) => {
    const translations = {
      total_teachers_by_management_category:
        "Total Teachers by Management Category",
      total_teacher_by_management_category:
        "Total Teacher by Management Category",
      category: "Category",
    };
    return translations[key] || key;
  };

  const casteCategories = {
    5: "Muslim",
    6: "Christian",
    7: "Sikh",
    8: "Buddhist",
    9: "PARSI",
    10: "Jain",
  };


      const graphDataPrepare = () => {
        ////Broad management////
    
        const broadManagement = [
          "State Government",
          "Govt. Aided",
          "Private Unaided",
          "Central Government",
          "Others",
        ];
        const broadCategory = [
          "Foundational and Preparatory",
          "Middle",
          "Secondary",
        ];
    
        const broadManagementSet = new Set(broadManagement);
        const graphMap = {
          1: 0,
          2: 1,
          3: 2,
          4: 3,
          5: 4,
          6: 5,
          7: 6,
          8: 7,
          9: 8,
          10: 9,
          11: 10,
          12: 11,
          13: 12,
          14: 13,
          15: 14,
          16: 15,
          17: 16,
          18: 17,
          19: 18,
          20: 19,
          21: 20,
        };
        // Precompute category sums
        const precomputedData = new Map();
    
        console.log('data', data)
        data.forEach((dataVal) => {
          if (!broadManagementSet.has(dataVal.schManagementBroad)) return;
    
          const totalCount = calculateSocialCategoryPieGraph(dataVal);
          const index = broadManagement.indexOf(dataVal.schManagementBroad);
          if (graphMap[dataVal.disablityId] !== undefined) {
            graphObject[graphMap[dataVal.disablityId]].data[index] =
              (graphObject[graphMap[dataVal.disablityId]].data[index] || 0) +
              totalCount;
          }
        });
    
        setGraphDataForManagementBroad({
          categories: broadManagement,
          series: graphObject,
        });
    
  
        console.log('graphObject', graphObject)
        // Function to compute the value for each data entry
        // const calculateSocialCategoryPieGraphForCategoryBroad = (dataVal) => {
        //   return parseInt(dataVal.totEnr) || 0;
        // };
    
        // data.forEach((dataVal) => {
        //   const casteName = casteCategories[dataVal.casteId];
        //   if (!casteName) return;
    
        //   if (foundational_preparatory.includes(dataVal.schCategoryId)) {
        //     graphObjectCategoryBroad[0].data[casteName] =
        //       (graphObjectCategoryBroad[0].data[casteName] || 0) +
        //       calculateSocialCategoryPieGraphForCategoryBroad(dataVal);
        //   }
    
        //   if (middle.includes(dataVal.schCategoryId)) {
        //     graphObjectCategoryBroad[1].data[casteName] =
        //       (graphObjectCategoryBroad[1].data[casteName] || 0) +
        //       calculateSocialCategoryPieGraphForCategoryBroad(dataVal);
        //   }
    
        //   if (secondary.includes(dataVal.schCategoryId)) {
        //     graphObjectCategoryBroad[2].data[casteName] =
        //       (graphObjectCategoryBroad[2].data[casteName] || 0) +
        //       calculateSocialCategoryPieGraphForCategoryBroad(dataVal);
        //   }
        // });
    
        // // Transform data to the required format
        // let transformedData = Object.keys(casteCategories).map((key) => {
        //   let casteName = casteCategories[key];
        //   return {
        //     name: casteName,
        //     data: graphObjectCategoryBroad.map(
        //       (category) => category.data[casteName] || 0
        //     ),
        //   };
        // });
    
        // setGraphDataForCatBroad({
        //   categories: broadCategory,
        //   series: transformedData,
        // });
  
        // console.log('transformedData', transformedData)
      };


  const onFilterChanged = () => {
    const gridApi = gridApiRef.current;
        const appendedObj = {};
        const removefirstTwoColumns = columns.slice(2);
        const visibleColumnsName = columns[1];
        const allData = [];
        gridApi.forEachNodeAfterFilter((node) => {
        allData.push(node.data);
      });
      visibleColumnsName?.children[0]?.children.forEach((item) => {
        if(!item.hide) appendedObj[item.field]="";
      });
      removefirstTwoColumns[0]?.children.forEach((items)=>{

     
        items.children.forEach((item) => {
            appendedObj[item.field] = filterCalculateTotal(allData,item.field);
        });
      })



        appendedObj['schCategoryBroad']="";
        appendedObj['schCategoryIdDesc']="";
        appendedObj['regionName']="";
        appendedObj['schManagementBroad']="";
        appendedObj['schMgmtCenterDesc']="";
        appendedObj['schTypeDesc']="";
        appendedObj['category']="";
      if(groupKeys.schManagementBroad){
        appendedObj['schManagementBroad']="Total";
      }else if(groupKeys.schMgmtCenterDesc){
        appendedObj['schMgmtCenterDesc']="Total";
      }else if(groupKeys.schCategoryBroad){
        appendedObj['schCategoryBroad']="Total";
      }else if(groupKeys.schCategoryIdDesc){
        appendedObj['schCategoryIdDesc']="Total";
      }else if(groupKeys.schTypeDesc){
        appendedObj['schTypeDesc']="Total";
      }else if(groupKeys.schLocationDesc){
        appendedObj['regionName']="Total";
      }
      else if(groupKeys.category){
        appendedObj['category']="Total";
      }

      if(filter_query_by_location){
        const columnDefs = gridApi.getColumnDefs();
        const childrenData = columnDefs[1].children;

        const fieldValue = childrenData.map((item) => item.children);
        let childrenData1 = fieldValue.flat();
        console.log(data)
        

        setIsCheckFilter(false);
        for (let i = 0; i < childrenData1.length; i++) {
          const columnId = childrenData1[i].field;
          const filterInstancePro = gridApi.getColumnFilterInstance(columnId);
          const getValueFromFilterInstance = async () => {
            try {
              const filterInstance = await filterInstancePro;
            if(filterInstance && filterInstance?.appliedModel !=null){
              if(filterInstance?.appliedModel?.values?.length != filterInstance?.valueModel?.allValues?.size){
                setIsCheckFilter(true);
              }
            }
            } catch (error) {
              console.error("Error fetching filter model:", error);
            }
          };
          getValueFromFilterInstance();
        }
      }


        setCustomChange([appendedObj]);
      };
    
    
      function filterCalculateTotal(data,fieldName) {
        if (!data) return 0;
        return data.reduce(
          (total, row) => total + parseFloat(row[fieldName] || 0),
          0
        );
      }

      const onFirstDataRendered = () => {
     
        setTimeout(() =>{
          if(arrGroupedData.length==0){

             const gridApi1 = gridApiRef.current;          
            const allData = [];        
            // const visibleColumns = gridApi.api.getAllDisplayedColumns();

            gridApi1.forEachNodeAfterFilter((node) => {
         
              if(node.data['School Management(Broad)'] !='Overall'){
            allData.push(node.data);
              }
          });
          const pinedBottomRowDatas = [
            {
              ...(getLastTrueToShowTotal()
                ? { [getLastTrueToShowTotal()]: "Total" }
                : { regionName: "Total" }),
                pp1G: calculateTotalSum(allData,"pp1G"),
                pp2B: calculateTotalSum(allData,"pp2B"),
                pp2G: calculateTotalSum(allData,"pp2G"),
                pp3B: calculateTotalSum(allData,"pp3B"),
                pp3G: calculateTotalSum(allData,"pp3G"),
                c2G: calculateTotalSum(allData,"c2G"),
              c2B: calculateTotalSum(allData,"c2B"),
              c3G: calculateTotalSum(allData,"c3G"),
              c3B: calculateTotalSum(allData,"c3B"),
              c1G: calculateTotalSum(allData,"c1G"),
              c1B: calculateTotalSum(allData,"c1B"),
              c4G: calculateTotalSum(allData,"c4G"),
              c4B: calculateTotalSum(allData,"c4B"),
              c5G: calculateTotalSum(allData,"c5G"),
              c5B: calculateTotalSum(allData,"c5B"),
              c6G: calculateTotalSum(allData,"c6G"),
              c6B: calculateTotalSum(allData,"c6B"),
              c7G: calculateTotalSum(allData,"c7G"),
              c8G: calculateTotalSum(allData,"c8G"),
              c7B: calculateTotalSum(allData,"c7B"),
              c8B: calculateTotalSum(allData,"c8B"),
              c9B: calculateTotalSum(allData,"c9B"),
              c10G: calculateTotalSum(allData,"c10G"),
              c9G: calculateTotalSum(allData,"c9G"),
              c10B: calculateTotalSum(allData,"c10B"),
              c11G: calculateTotalSum(allData,"c11G"),
              c11B: calculateTotalSum(allData,"c11B"),
              c12G: calculateTotalSum(allData,"c12G"),
              c12B: calculateTotalSum(allData,"c12B"),
              total:
              calculateTotalSum(allData,"pp1G") +
              calculateTotalSum(allData,"pp2B") +
              calculateTotalSum(allData,"pp2G") +
              calculateTotalSum(allData,"pp3B") +
              calculateTotalSum(allData,"pp3G") +
              calculateTotalSum(allData,"c2G") +
                calculateTotalSum(allData,"c2B") +
                calculateTotalSum(allData,"c3B") +
                calculateTotalSum(allData,"c1B") +
                calculateTotalSum(allData,"c3G") +
                calculateTotalSum(allData,"c1G") +
                calculateTotalSum(allData,"c4G") +
                calculateTotalSum(allData,"c5G") +
                calculateTotalSum(allData,"c4B") +
                calculateTotalSum(allData,"c6G") +
                calculateTotalSum(allData,"c5B") +
                calculateTotalSum(allData,"c7G") +
                calculateTotalSum(allData,"c6B") +
                calculateTotalSum(allData,"c7B") +
                calculateTotalSum(allData,"c8G") +
                calculateTotalSum(allData,"c9B") +
                calculateTotalSum(allData,"c8B") +
                calculateTotalSum(allData,"c9G") +
                calculateTotalSum(allData,"c10G") +
                calculateTotalSum(allData,"c11G") +
                calculateTotalSum(allData,"c10B") +
                calculateTotalSum(allData,"c12G") +
                calculateTotalSum(allData,"c11B") +
                calculateTotalSum(allData,"c12B")
            },
          ];
          const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
          ? (  pinedBottomRowDatas)
          : [];
          setCustomChange(pinnedBottomRowData);
  
          }else{
            setCustomChange(pinnedBottomRowData);
          }
          
        },10)
       
    };
        
            useEffect(() => {
              if (data.length > 0) {
                onFirstDataRendered();
              }
            }, [data]);


            
  return (
    <>
      <ScrollToTopOnMount onScrollComplete={handleScrollComplete} />
      {schData.isLoading && <GlobalLoading />}
      <section className="infrastructure-main-card p-0" id="content">
        <div className="bg-grey2 pb-0 pt-0 header-bar tab-for-graph">
          <div className="blue-strip">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-10 col-lg-10">
                  <div className="common-content text-start map-heading-map">
                    {report && (
                      <div className="common-content text-start map-heading-map d-flex align-items-center">
                        <span className="me-3">
                          {t("reports_id")}
                          {report.id}
                        </span>
                        <h2 className="heading-sm1 mb-0 mt-0">
                          {report.report_name}
                        </h2>
                      </div>
                    )}
                  </div>
                </div>

                {activeTab !== "about" && activeTab !== "graph" && (
                  <div className="col-md-2 col-lg-2">
                    <div className="select-infra button-group-filter">
                      <div className="indicator-select">
                        <select
                          id="export_data"
                          className="form-select bg-grey2"
                          onChange={handleExportData}
                          defaultValue={""}
                        >
                          <option className="option-hide">
                            {" "}
                            {t("download_report")}
                          </option>
                          <option value="export_pdf">
                            {t("download_as_pdf")}{" "}
                          </option>
                          <option value="export_excel">
                            {" "}
                            {t("download_as_excel")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container pb-4">
            <div className="row">
            {activeTab !== "about" && activeTab !== "graph" && (
                <div className="col-md-12 col-lg-12 d-flex align-items-center">
                  <div className="tab-text-infra me-4">
                    {" "}
                    {t("view_data_by")}
                  </div>
                  <ul className="nav nav-tabs mul-tab-main">
                    <li className={`nav-item ${multiMgt}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active ${mgt}`}
                        onClick={(e) =>
                          handleButtonClick("School Management", "broad", e)
                        }
                      >
                        {t("school_management_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active details-multi ${mgt_Details}`}
                        id="school_mgt_details"
                        onClick={(e) =>
                          handleButtonClick("School Management", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li>
                    {/* <li className={`nav-item ${multiCat}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active1 ${cat}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "broad", e)
                        }
                      >
                        {t("school_category_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active1 details-multi ${cat_Details}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li> */}
                    {/* <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${ur}`}
                        onClick={(e) =>
                          handleButtonClick("Urban/Rural", "broad", e)
                        }
                      >
                        {t("urban_rural")}
                      </button>
                    </li> */}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-grey ptb-30">
          <div className="container tab-for-graph">
            <div className="row align-items-center report-inner-tab">
              <div className="col-md-12 col-lg-12 table-text-i table-brud-card">
                {activeTab !== "about" && (
                  <h4 className="brudcrumb_heading">
                    {t("showing_result_for")} <span>&nbsp;{local_state}</span>
                    <span className="material-icons-round">chevron_right</span>
                    {local_district !== "District" && (
                      <>
                        <span>{local_district}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    {local_block !== "Block" && (
                      <>
                        <span>{local_block}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    <span>{local_year}</span>
                  </h4>
                )}
                <Tabs
                  defaultActiveKey={type}
                  id="uncontrolled-tab-example"
                  className="nav-absolute"
                  onSelect={(k) => setActiveTab(k)}
                >
                  {/* <Tab eventKey="about" title={t("about")}>
                    <div className="about-card mt-4">
                      <h2 className="heading-sm2 mb-2">{t("about_us")}</h2>
                      <p>The "Enrolment by Location, School Category, and School Management for Each Class & Level of Education by Minority" refers to the detailed analysis of student enrolment patterns, specifically focusing on minority groups, across various educational locations, school categories, and management types. This data provides a comprehensive view of how students from minority communities are distributed across different types of schools and educational levels.

Location in this context refers to the geographical area where the school is located, such as urban or rural regions, and even more localized areas like districts or states. This classification helps to identify whether minority students are concentrated in specific areas or if they have equitable access to education across different locations.<br />

School category refers to the level of education offered, such as primary, upper primary, secondary, or higher secondary schools. It allows for an understanding of whether minority students are enrolling at different stages of education, and if there are specific educational levels where their enrolment might be higher or lower.<br />

School management includes the types of schools—government-run, private, government-aided, or others. This classification helps assess how minority students are distributed between public and private institutions, and whether certain management types are more inclusive or accessible to these communities.<br />

Finally, the data is broken down by minority, which refers to students from minority communities, including linguistic, religious, or cultural minorities. This segmentation ensures that the enrolment figures specifically reflect the participation of these groups, which is crucial for assessing the effectiveness of educational policies aimed at promoting inclusion and equity.<br />

By analyzing this data, policymakers can better understand the enrolment trends of minority students, identify regions or school types that may need more support, and develop targeted strategies to increase minority participation in education. It also helps in assessing whether minority communities have equal access to quality education at all levels and in various school management systems, thus supporting efforts to reduce disparities and promote inclusive education for all.
</p>
                    </div>
                  </Tab> */}
                  <Tab eventKey="table" title={t("table")}>
                    <div className="multi-header-table">
                      <div
                        className=" multi-header-table ag-theme-quartz ag-theme-custom-height h-300"
                        style={{ height: 450 }}
                      >
                        <AgGridReact
                          key={gridRefreshKey}
                          rowData={
                            isCheckFilter ? arrGroupedData : filter_query_by_location &&
                            (groupKeys.schManagementBroad ||
                              groupKeys.schMgmtCenterDesc ||
                              groupKeys.schCategoryBroad ||
                              groupKeys.schCategoryIdDesc ||
                              groupKeys.schLocURDesc ||
                              groupKeys.category)
                              ? result
                              : arrGroupedData
                              ? arrGroupedData
                              : []
                          }

                          
                        getRowStyle={(params) => {
                          if (params.data.isTotalRow) {
                            return { fontWeight: 'bold' };  // Apply inline bold style for totals row
                          }
                          return {};  // Default style for other rows
                        }}
                          columnDefs={columns}
                          defaultColDef={defColumnDefs}
                          onColumnVisible={onColumnVisible}
                          onGridReady={onGridReady}
                          groupDisplayType="custom"
                          firstDataRendered={onFirstDataRendered}
                          groupHideOpenParents={true}
                          onFilterChanged={onFilterChanged}
                          pinnedBottomRowData={customChange}
                          excelStyles={excelStyles}
                        />
                      </div>
                    </div>
                  </Tab>
                  <Tab disabled eventKey="graph" title={t("chart")}>
                    <div className="card-box-impact tab-for-graph report-2008 mt-4 tab-content-reduce">
                      <div className="row">


                         <div className="col-md-12 col-lg-12">
                                                                          <div className="impact-box-content-education">
                                                                            <div className="text-btn-d">
                                                                              <h2 className="heading-sm">
                                                                                Total Number of Enrolment of CWSN Children by School
                                                                                management ( Broad )
                                                                              </h2>
                                                                            </div>
                                                
                                                                            <div className="piechart-box mt-4">
                                                                              <Graph4007
                                                                                graphScmSchDataBrod={
                                                                                  graphDataForManagementBroad
                                                                                }
                                                                                t={trans}
                                                                                title="Total Number of Enrolment of CWSN Children by School
                                                                                management ( Broad )"
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                        </div>


                        <div className="col-md-12 col-lg-12">
                                                                         <div className="impact-box-content-education mt-3">
                                                                           <div className="text-btn-d">
                                                                             <h2 className="heading-sm">
                                                                               Percentage of Enrolment by Social Category
                                                                             </h2>
                                                                           </div>
                                               
                                                                           <div className="piechart-box mt-4">
                                                                             <HighchartsReact
                                                                               highcharts={Highcharts}
                                                                               options={{
                                                                                 chart: {
                                                                                   type: "pie",
                                                                                   width: 1250, // Set desired width
                                                                                   height: 400, // Set desired height
                                                                                   marginTop: 50,
                                                                                   events: {
                                                                                     beforePrint: function () {
                                                                                       this.exportSVGElements[0].box.hide();
                                                                                       this.exportSVGElements[1].hide();
                                                                                     },
                                                                                     afterPrint: function () {
                                                                                       this.exportSVGElements[0].box.show();
                                                                                       this.exportSVGElements[1].show();
                                                                                     },
                                                                                   },
                                                                                 },
                                                                                 title: {
                                                                                   text: "Percentage of Enrolment by Social Category",
                                                                                 },
                                                                                 tooltip: {
                                                                                   pointFormat:
                                                                                     "<b>{point.name}</b>: {point.percentage:.2f}%", // Auto percentage
                                                                                 },
                                                                                 credits: {
                                                                                   enabled: false,
                                                                                 },
                                                                                 plotOptions: {
                                                                                   pie: {
                                                                                     size: "100%",
                                                                                     dataLabels: {
                                                                                       enabled: true,
                                                                                       distance: 30,
                                                                                       alignTo: isMobile ? "connectors" : null,
                                                                                       connectorShape: "crookedLine",
                                                                                       crookDistance: "100%",
                                                                                       format: "<b>{point.percentage:.2f}%", // Auto percentage
                                                                                       style: {
                                                                                         fontSize: "16px",
                                                                                         textOutline: "none",
                                                                                         opacity: 0.7,
                                                                                       },
                                                                                     },
                                                                                     center: ["75%", "50%"],
                                                                                     showInLegend: true,
                                                                                   },
                                                                                   series: {
                                                                                     allowPointSelect: true,
                                                                                     cursor: "pointer",
                                                                                     dataLabels: [
                                                                                       {
                                                                                         enabled: true,
                                                                                         distance: 20,
                                                                                       },
                                                                                       {
                                                                                         enabled: false,
                                                                                         distance: 30,
                                                                                         format: "{point.y:.2f}%",
                                                                                         style: {
                                                                                           fontSize: "0.6em",
                                                                                           textOutline: "none",
                                                                                           opacity: 0.7,
                                                                                         },
                                               
                                                                                         filter: {
                                                                                           operator: ">",
                                                                                           property: "percentage",
                                                                                           value: 0,
                                                                                         },
                                                                                       },
                                                                                     ],
                                                                                   },
                                                                                 },
                                                                                 legend: {
                                                                                  layout: "vertical", // Arrange legend items vertically
                                                                                  align: "left", // Move legend to the left
                                                                                  verticalAlign: "middle", // Center legend vertically
                                                                                  itemMarginTop: 5,
                                                                                  itemMarginBottom: 5,
                                                                                  symbolHeight: 10, // Adjust color box size
                                                                                  symbolWidth: 10, // Adjust color box size
                                                                                  symbolRadius: 0, // Make legend symbols square
                                                                                 },
                                                                                 series: [
                                                                                   {
                                                                                     name: t("percentage"),
                                                                                     colorByPoint: true,
                                                                                     data: [
                                                                                      {
                                                                                        name: "Blindness",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.blindness),
                                                                                        color: "#F5BF55",
                                                                                      },
                                                                                      {
                                                                                        name: "Low Vision",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.low_vision),
                                                                                        color: "#E6694A",
                                                                                      },
                                                                                      {
                                                                                        name: "Hearing impairment",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.hearing_impairment),
                                                                                        color: "#BCE263",
                                                                                      },
                                                                                      {
                                                                                        name: "Speech and Language",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.speech_and_language),
                                                                                        color: "#751539",
                                                                                      },
                                                                                      {
                                                                                        name: "Locomotor Disability",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.locomotor_disability),
                                                                                        color: "#43A047",
                                                                                      },
                                                                                      {
                                                                                        name: "Mental illness",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.mental_illness),
                                                                                        color: "#1E88E5",
                                                                                      },
                                                                                      {
                                                                                        name: "Specific Learning Disabilities",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.specific_learning_disabilities),
                                                                                        color: "#F57C00",
                                                                                      },
                                                                                      {
                                                                                        name: "Cerebral palsy",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.cerebral_palsy),
                                                                                        color: "#8E24AA",
                                                                                      },
                                                                                      {
                                                                                        name: "Autism Spectrum Disorder",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.autism_spectrum_disorder),
                                                                                        color: "#0097A7",
                                                                                      },
                                                                                      {
                                                                                        name: "Multiple Disability incl. deaf, blindness",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.multiple_disability),
                                                                                        color: "#6D4C41",
                                                                                      },
                                                                                      {
                                                                                        name: "Leprosy Cured students",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.leprosy_cured),
                                                                                        color: "#00ACC1",
                                                                                      },
                                                                                      {
                                                                                        name: "Dwarfism",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.dwarfism),
                                                                                        color: "#D81B60",
                                                                                      },
                                                                                      {
                                                                                        name: "Intellectual Disability",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.intellectual_disability),
                                                                                        color: "#3949AB",
                                                                                      },
                                                                                      {
                                                                                        name: "Muscular Dystrophy",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.muscular_dystrophy),
                                                                                        color: "#558B2F",
                                                                                      },
                                                                                      {
                                                                                        name: "Chronic Neurological conditions",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.chronic_neurological_conditions),
                                                                                        color: "#FDD835",
                                                                                      },
                                                                                      {
                                                                                        name: "Thalassemia",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.thalassemia),
                                                                                        color: "#5D4037",
                                                                                      },
                                                                                      {
                                                                                        name: "Haemophilia",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.haemophilia),
                                                                                        color: "#C2185B",
                                                                                      },
                                                                                      {
                                                                                        name: "Sickle Cell disease",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.sickle_cell_disease),
                                                                                        color: "#7B1FA2",
                                                                                      },
                                                                                      {
                                                                                        name: "Acid Attack victim",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.acid_attack_victim),
                                                                                        color: "#00796B",
                                                                                      },
                                                                                      {
                                                                                        name: "Parkinson’s disease",
                                                                                        y: parseFloat(socialCategoryPieDataGraph?.parkinsons_disease),
                                                                                        color: "#FF7043",
                                                                                      },
                                                                                    ],
                                                                                    
                                                                                   },
                                                                                 ],
                                                                                 exporting: {
                                                                                   filename: t(
                                                                                     "percentage_schools_by_management"
                                                                                   ),
                                                                                   csv: {
                                                                                     columnHeaderFormatter: function (item) {
                                                                                       if (
                                                                                         !item ||
                                                                                         item instanceof Highcharts.Axis
                                                                                       ) {
                                                                                         return t("category");
                                                                                       }
                                                                                       return item.name;
                                                                                     },
                                                                                   },
                                                                                 },
                                                                               }}
                                                                               immutable={true}
                                                                             />
                                                                           </div>
                                                                         </div>
                                                                       </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <FilterDropdownCommom358 />
    </>
  );
}
